export const isIntegrationEnvironment = () => window?.location?.href?.includes('checkout.integration');

export const getCurrentEnvironment = () => {
  if (typeof window === 'undefined') return 'unknown';

  const href = window.location.href;

  if (href.includes('localhost') || href.includes('127.0.0.1') || href.includes('0.0.0.0')) {
    return 'local';
  }

  if (href.includes('checkout.integration')) {
    return 'integration';
  }

  return 'production';
};
